<div class="nv-rail__head">
  @if (logoUrl(); as logo) {
    <img class="nv-rail__logo" [src]="logo" alt="" />
  } @else {
    <span class="nv-rail__logo nv-rail__logo--mark">{{ (venueName() || 'N').charAt(0).toUpperCase() }}</span>
  }
  @if (!collapsed()) {
    <span class="nv-rail__brand">
      <span class="nv-rail__brand-title">{{ venueName() || 'NexVenueX' }}</span>
      @if (venueContext(); as context) {
        <span class="nv-rail__brand-sub">{{ context }}</span>
      }
    </span>
  }
</div>

@if (!collapsed()) {
  <nv-venue-switcher />
}

<nav class="nv-rail__nav nvx-scroll" aria-label="Main">
  @for (section of groups(); track section.group; let si = $index) {
    @if (!collapsed()) {
      <p class="nv-rail__group-label">{{ section.group }}</p>
    } @else if (!$first) {
      <hr class="nv-rail__rule" />
    }
    <ul class="nv-rail__list">
      @for (item of section.items; track item.path + (item.queryParams?.['view'] ?? ''); let ii = $index) {
        <li>
          <a
            class="nv-rail__item"
            [routerLink]="item.path"
            [queryParams]="item.queryParams ?? null"
            routerLinkActive="nv-rail__item--active"
            [routerLinkActiveOptions]="{ exact: false }"
            [attr.aria-label]="collapsed() ? item.label : null"
            [attr.aria-describedby]="badgeFor(item.path) ? 'nv-rail-badge-' + si + '-' + ii : null"
            [nvTooltip]="collapsed() ? item.label : ''"
            nvTooltipPosition="right"
          >
            <nv-icon [size]="21">{{ item.icon }}</nv-icon>
            @if (!collapsed()) {
              <span class="nv-rail__item-label">{{ item.label }}</span>
            }
            @if (badgeFor(item.path); as badge) {
              <!-- aria-hidden: without it this count concatenates into the
                   link's own accessible name ("Tables" becomes "Tables 1"),
                   which is wrong for a screen reader and breaks anything
                   that finds this link by its exact name. The count is
                   announced instead as the link's description (the
                   hidden span below, via aria-describedby — hidden spans
                   still feed a description but not the name). -->
              @if (collapsed()) {
                <span class="nv-rail__badge-dot" aria-hidden="true"></span>
              } @else {
                <span class="nv-rail__badge" aria-hidden="true">{{ badge }}</span>
              }
              <span class="nv-rail__sr-only" aria-hidden="true" [id]="'nv-rail-badge-' + si + '-' + ii">{{ badge }} need attention</span>
            }
          </a>
        </li>
      }
    </ul>
  }
</nav>

<div class="nv-rail__footer">
  <ul class="nv-rail__list">
    @for (item of footerItems(); track item.path) {
      <li>
        <a
          class="nv-rail__item"
          [routerLink]="item.path"
          routerLinkActive="nv-rail__item--active"
          [attr.aria-label]="collapsed() ? item.label : null"
          [nvTooltip]="collapsed() ? item.label : ''"
          nvTooltipPosition="right"
        >
          <nv-icon [size]="21">{{ item.icon }}</nv-icon>
          @if (!collapsed()) {
            <span class="nv-rail__item-label">{{ item.label }}</span>
          }
        </a>
      </li>
    }
    <li>
      <a
        class="nv-rail__item"
        [href]="supportHref"
        [attr.aria-label]="collapsed() ? 'Help & support' : null"
        [nvTooltip]="collapsed() ? 'Help & support' : ''"
        nvTooltipPosition="right"
      >
        <nv-icon [size]="21">help</nv-icon>
        @if (!collapsed()) {
          <span class="nv-rail__item-label">Help &amp; support</span>
        }
      </a>
    </li>
  </ul>

  <div
    class="nv-rail__save"
    [attr.data-tone]="saveState().tone"
    role="status"
    [nvTooltip]="collapsed() ? saveState().label : ''"
    nvTooltipPosition="right"
  >
    <span class="nv-rail__save-dot" aria-hidden="true"></span>
    @if (!collapsed()) {
      <span>{{ saveState().label }}</span>
    } @else {
      <span class="nv-rail__sr-only">{{ saveState().label }}</span>
    }
  </div>
</div>
